import React, { useState } from "react";
import { MapPin, Check } from "lucide-react";
import MapEmbed from "./MapEmbed";

// Admin helper shown under a location field: lets the admin confirm the typed
// location on a Google Map before saving. Members see the same map on the event.
export default function MapConfirm({ query, testidPrefix = "map-confirm" }) {
  const [open, setOpen] = useState(false);
  const q = (query || "").trim();
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3" data-testid={`${testidPrefix}-block`}>
      <button type="button" disabled={!q} onClick={() => setOpen((o) => !o)} data-testid={`${testidPrefix}-toggle`}
        className="w-full flex items-center justify-center gap-2 rounded-full py-2 text-sm font-semibold border border-[#D4AF37]/30 bg-[#D4AF37]/10 text-[#D4AF37] disabled:opacity-40 disabled:cursor-not-allowed active:scale-[0.98] transition-transform">
        <MapPin size={15} /> {q ? (open ? "Hide map" : "Confirm location on Google Maps") : "Enter a location first"}
      </button>
      {open && q && (
        <div className="mt-3">
          <p className="text-[11px] text-[#A19DB0] mb-2 flex items-center gap-1.5">
            <Check size={12} className="text-[#4ADE80]" /> Check the pin is the right place — members see this map on the event.
          </p>
          <MapEmbed query={q} height={200} />
        </div>
      )}
    </div>
  );
}
